import api from "./api";

export const postCourt = async (body) => {
  return api
    .post({
      body,
      endpoint: "/own/court",
      port: process.env.REACT_APP_PORT_COURT,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
